import { ShowDateFormat } from "@evennt-tech/api-v2-core";
import { format, Locale } from "date-fns";

const formatDate = (
  date: Date,
  dateFormat: string = ShowDateFormat.dayFirst,
  locale?: Locale
): string => format(date, dateFormat, locale ? { locale } : undefined);

export const formatISODate = (
  date: string,
  dateFormat: string = ShowDateFormat.dayFirst,
  locale?: Locale
): string => {
  return format(new Date(date), dateFormat, locale ? { locale } : undefined);
};

export const formatStartAndEnd = (
  start: Date,
  end: Date,
  dateFormat = `${ShowDateFormat.dayFirst}, HH:mm`
) => {
  return `${format(start, dateFormat)} - ${format(end, dateFormat)}`;
};
export const formatRange = (
  start: Date | number,
  end: Date | number,
  dateFormat: ShowDateFormat,
  locale?: Locale
) => {
  const opts = locale ? { locale } : undefined;
  const startYear = format(start, "yyyy", opts);
  const endYear = format(end, "yyyy", opts);
  const isSameYear = startYear === endYear;

  switch (dateFormat) {
    case ShowDateFormat.monthFirst:
      return isSameYear
        ? `${format(start, "MMM d", opts)} — ${format(end, "MMM d yyyy", opts)}`
        : `${format(start, "MMM d yyyy", opts)} — ${format(
            end,
            "MMM d yyyy",
            opts
          )}`;

    case ShowDateFormat.yearFirst:
      return isSameYear
        ? `${format(start, "yyyy MMM d", opts)} — ${format(end, "MMM d", opts)}`
        : `${format(start, "yyyy MMM d", opts)} — ${format(
            end,
            "yyyy MMM d",
            opts
          )}`;

    default:
      return isSameYear
        ? `${format(start, "d MMM", opts)} — ${format(end, "d MMM yyyy", opts)}`
        : `${format(start, "d MMM yyyy", opts)} — ${format(
            end,
            "d MMM yyyy",
            opts
          )}`;
  }
};
export default formatDate;
